<app-toolbar (menuToggleEvent)="sideNav.leftSidenav().toggle()" (clickEvent)="sideNav.toggleRightMenu($event)" />
<app-sidenav #sideNav />